module.exports = __webpack_public_path__ + "static/media/surfing_640.36c2e1d6.webp";